import { Fragment } from 'react';
import { Typography } from '../../../molecules/Typography';

interface IMaterialContent {
  type: string;
}

export function MaterialContent({ type }: IMaterialContent) {
  const material_type = () => {
    if (type === 'mapa_mental' || type === 'mindmap') {
      return 'Mapa mental';
    }

    if (type === 'dossie') {
      return 'Dossiê';
    }

    if (type === 'exercicio') {
      return 'Lista de exercício';
    }

    return 'Apostila';
  };

  return (
    <Fragment>
      <Typography
        size='small'
        className='transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {material_type()}
      </Typography>
    </Fragment>
  );
}
